<div class="d-flex flex-row justify-content-end">
  <button class="btn btn-primary" (click)="addCompanyTemplate()" translate>ADD_NEW_CUSTOMER_TEMPLATE</button>
</div>

<lib-filter-list #productList [configService]="companyTemplatesListConfig"></lib-filter-list>
